import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { toast } from 'react-toastify';
import { StudentScholarshipsStatus } from '../../../../../../api/types/students/student-scholarships/student-scholarship-entity';

export const updateStudentScholarshipStatusOperation = async (
  userId: number,
  scholarshipId: number,
  status: StudentScholarshipsStatus,
  setIsLoading: (loading: boolean) => any,
  closeDialog: () => any,
) => {
  setIsLoading(true);
  try {
    const response = await appApi.updateStudentScholarshipStatus(
      userId,
      scholarshipId,
      status,
    );

    if (!response.data.ok) {
      toast.error('עדכון סטטוס המלגה נכשל');
      return;
    }

    toast.success('סטטוס המלגה עודכן בהצלחה');

    const updatedUserDetails = await appApi.getUserStudentDetails(userId);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    closeDialog();
  } catch (error) {
    console.error(
      `updateStudentScholarshipStatusOperation failed with error: ${error}`,
    );
    toast.error('אירעה שגיאה בעת עדכון סטטוס המלגה');
  } finally {
    setIsLoading(false);
  }
};
